import {useEffect, useState} from "react";
import {Bounce, toast} from "react-toastify";
import {getComponentsForEquipments} from "../../services/Administrative/equipmentService";

interface ComponentType {
    [key: string]: string;
}

interface ClientsType {
    [key: string]: { [key: string]: string };
}

export const useGetComponentsForEquipments = () => {

    const [dispenser, setDispensers] = useState<ComponentType>({});
    const [controller, setController] = useState<ComponentType>({});
    const [agitator, setAgitator] = useState<ComponentType>({});
    const [tank, setTank] = useState<ComponentType>({});
    const [additives, setAdditives] = useState<ComponentType>({});
    const [clients, setClients] = useState<ClientsType>({});

    useEffect(() => {
        const fetchComponents = async () => {
            try {
                const response:any = await getComponentsForEquipments();
                setDispensers(response.components.DISPENSER);
                setController(response.components.CONTROLLER);
                setTank(response.components.TANK);
                setAgitator(response.components.AGITATOR);
                setAdditives(response.additives);
                setClients(response.clients);
            } catch (error:any) {
                if (error.response) {
                    if (error.response.status === 404) {
                        toast.warning(
                            `${error.response.data.message}. Por favor, verifique o limpie los filtros`,
                            {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,
                                theme: 'colored',
                                transition: Bounce,
                            }
                        );
                    } else {
                        toast.error("Error al obtener los componentes para equipos.", {
                            position: 'top-right',
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                            theme: 'colored',
                            transition: Bounce,
                        });
                    }
                } else {
                    toast.error("Error al obtener los components para equipos.", {
                        position: 'top-right',
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: 'colored',
                        transition: Bounce,
                    });
                }
            }
        };
        fetchComponents();
    }, []);

    return { dispenser, controller , tank, agitator, additives, clients };
};
